import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">热度榜单</h2>
          <p className="mt-2 text-sm text-foreground-500">实时热度 · 大家都在看</p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden">
            {rankingData.map((item, idx) => (
              <a
                key={item.id}
                href="#cards"
                className={`flex items-center gap-4 p-4 hover:bg-primary-50/30 transition-colors cursor-pointer ${
                  idx < rankingData.length - 1 ? 'border-b border-background-200/40' : ''
                }`}
              >
                <span
                  className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                    idx === 0
                      ? 'bg-accent-500 text-background-50'
                      : idx === 1
                      ? 'bg-secondary-500 text-background-50'
                      : idx === 2
                      ? 'bg-primary-400 text-background-50'
                      : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  {idx + 1}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.title}</h3>
                    <span className="px-2 py-0.5 bg-background-200 text-foreground-500 rounded text-xs whitespace-nowrap">
                      {item.type}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
                </div>
                <span className="text-xs text-foreground-400 whitespace-nowrap flex-shrink-0">{item.hot}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}